import { useEffect, useState } from "react";

import Image from "next/image";

import classNames from "classnames";

import Styles from "./ProductImagePreview.module.css";

function ProductImagePreview({ productName, previewImages }) {
  const [activeImage, setActiveImage] = useState(previewImages[0]);

  useEffect(() => {
    setActiveImage(previewImages[0]);
  }, [previewImages]);

  return (
    <section>
      <div className="block w-full space-y-[1.5rem] lg:flex  lg:h-[33.75rem] lg:flex-row-reverse lg:space-y-0">
        <div className="relative aspect-square w-full rounded-[0.75rem]  bg-[#F5F8FA] lg:w-[72%]">
          <Image
            fill
            quality={40}
            src={activeImage}
            alt={productName}
            className="object-contain"
            sizes="(max-width: 768px) 100vw, 33vw"
          />
        </div>

        <div className="lg:w-[28%]">
          <div
            className={`${Styles.customScrollBar} relative flex h-full space-x-[3%]  space-y-0 overflow-x-auto pb-2 md:space-y-[1rem] lg:w-[87%] lg:flex-col lg:space-x-0 lg:pb-0`}
          >
            {previewImages.map((imagePath) => (
              <div
                key={imagePath}
                className={classNames(
                  {
                    "border-primary": imagePath === activeImage,
                  },
                  {
                    "border-white": imagePath !== activeImage,
                  },
                  `flex aspect-square w-[24%] shrink-0 items-center justify-center rounded-[0.625rem] border transition-all hover:border-primary lg:w-[95%]`
                )}
                onClick={() => setActiveImage(imagePath)}
              >
                <div className="relative h-full w-full">
                  <Image
                    fill
                    quality={40}
                    sizes="640px"
                    src={imagePath}
                    alt={productName}
                    className="rounded-[0.75rem] object-contain"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductImagePreview;
